import { Product } from '../../products/interfaces/product.interface';
import { Item } from '../../shared/models/item.model';
import { Cart } from '../../shared/models/cart.model';
import { UserTitleType } from '../../shared/enums/user-title-type.enum';
import { CommonService } from '../../shared/services/common.service';
import { CartService } from '../../shared/services/cart.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CacheService } from '../../shared/services/cache.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { ImageType } from '../../products/enums/image-type.enum';
import remove from 'lodash-es/remove';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { PurchaseFlow } from '../../shared/enums/purchase-flow.enum';
import { StoreConfig } from '../../shared/interfaces/store-config.interface';
import { CartTypes } from '../../shared/enums/cart-types.enum';
import { environment } from '../../../environments/environment';
import { AppMessageService } from '../../app-message.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductType } from '../../products/enums/product-types.enum';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap';
import { QuickviewComponent } from './quickview.component';
import { ProductService } from '../services/product.service';
import { MemberLevel } from '../../shared/enums/member-level.enum';
import { ActiveSessionService } from '../../shared/services/active-session.service';
import { NotificationType } from '../enums/notification-type.enum';
import { NotificationService } from '../../shared/services/notification.service';
import { TranslateParam } from '../interfaces/translate-param.interface';
import { ProductMetatDataValue } from '../enums/product-metadata.enum';
import { MemberOrderRestrictionService } from 'src/app/shared/services/member-order-restriction.service';
import { DisplayPriceConfig } from 'src/app/shared/interfaces/display-price-config.interface';
import { MemberDisplayPriceConfigService } from 'src/app/shared/services/member-display-price-config.service';
import { PortalDisplayPage } from 'src/app/shared/enums/portal-display-page.enum';

@Component({
  selector: 'app-bestseller-products',
  templateUrl:
    '../templates/template1/views/bestseller-products.component.html',
  styleUrls: [
    '../templates/template1/themes/less/bestseller-products.component.less'
  ]
})
export class BestSellerProductsComponent implements OnDestroy, OnInit {
  isPersonalPurchaseFlow = false;
  personalPurchaseFlow: any = PurchaseFlow.PERSONAL;
  purchaseFlows: any[] = [];
  store: StoreConfig;
  userLoggedIn: any;
  featuredProducts: Product[];
  errorMessages: any = [];
  productId = 1;
  selectedCurrency = 'USD';
  languageCode: string;
  storeId: number;
  groupId = 1;
  imageTypes: any = ImageType;
  @Input() hideWishList: boolean;
  @Input() isRecommended = false;
  @Input() catalog: any;
  hideWishListItems: boolean;
  memberTitle = MemberLevel;
  memberTitleId: number = MemberLevel.RETAIL;
  config: any;
  isoCountryCode: string;
  hideItemsSubscription: any;
  isLoggedIn = false;
  catalogConfig: any;
  showOptions = false;
  bsModalRef: BsModalRef;
  productType = ProductType;
  isEnableWishList: boolean;
  translateParams: TranslateParam;
  displayPriceConfig: DisplayPriceConfig;
  public featuredSliderConfig: SwiperConfigInterface = {
    slidesPerView: 3,
    touchRatio: 0.2,
    navigation: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      930: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    }
  };


  constructor(
    private _cacheService: CacheService,
    private _productService: ProductService,
    private _cartService: CartService,
    private _commonService: CommonService,
    private modalService: BsModalService,
    private _configurationService: ConfigurationService,
    private _appMessageService: AppMessageService,
    private _translatePipe: TranslateService,
    private _activeSessionService: ActiveSessionService,
    private _notificationService: NotificationService,
    private memberOrderRestrictionService: MemberOrderRestrictionService,
    private memberDisplayPriceConfigService: MemberDisplayPriceConfigService
  ) { }
  ngOnInit() {
    this.getStoreData();
    this.userLoggedIn = this._cacheService.get(CacheKey.UserInfo);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.isLoggedIn = this._cacheService.get(CacheKey.UserInfo);
    this.displayPriceConfig = this.memberDisplayPriceConfigService
      .getDisplayPriceConfig(this._commonService.prepareMemberDisplayConfigInfo(PortalDisplayPage.ProductList, this.store.taxInclusive,
         this.userLoggedIn, false, this.store.taxInclusive));
    this.getOptionsConfig();
    this.featuredSliderConfig.slidesPerView = this.config.options.slides;
    this.memberTitleId = this._activeSessionService.getMemberTitleId();
    this.getProductsByCatalogId(this.catalog.id);
  }
  /**
 * goto detail page in shop
 * @param  {string} slug
 * @returns void
 */
  gotoProductDetail(slug: string): void {
    let url = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/' +
      this.languageCode.toLowerCase() + '/products/' + slug;
    url = this._commonService.appendFBOID(url);
    window.location.href = url;
  }
  /**
    * Load Products By catalog Id
    * @param  {number} catalogId
    * @param  {number} pageSize?
    * @param  {boolean} isSort?
    * @returns void
    */
  getProductsByCatalogId(categoryId: number): void {
    if (this.storeId && categoryId) {
      this._productService.getProductsByCatalogId(this.storeId, categoryId, this.languageCode, 10, 1, 'FEATURED')
        .subscribe((products: Product[]) => {
          if (products) {
            this.featuredProducts = products;
            this.featuredProducts.forEach(x => {
              if (!x.stockAvailable || (x.manageStock && !x.backOrderAllowed && x.stockQuantity <=0 )) {
              //if (!(x.backOrderAllowed || (x.manageStock && x.stockQuantity > 0))) {
                x.productQuantity = 0;
              } else {
                x.productQuantity = 1;
              }
              if (ProductType.Variable === x.productTypeMasterId) {
                this.showOptions = true;
              } else {
                this.showOptions = false;
              }
              x.disableDecrement = x.productQuantity > 1 ? false : true;
              if (x.shipping) {
                x.commissionableVolume = !x.shipping.literature ? x.commissionableVolume : 0;
              }
              const bestValues = x.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.BEST_VALUES);
              if (bestValues && bestValues.metaKeyWords === '1') {
                x.display.bestValues = true;
              } else {
                x.display.bestValues = false;
              }
            });
          }
          setTimeout(() => {
            this.loadWishListProducts();
          }, 2000);
        }, (error: any) => {
          this.translateParams = this._commonService.handleError(error);
        });
    }
  }
  // for Group Name we configured later will drive from Store Config
  private getOptionsConfig(): void {
    const featuredProductsConfig: any = [
      {
        countryCode: 'usa',
        options: {
          name: this.isRecommended ? 'featuredProducts.Recommended Products' : 'featuredProducts.Featured Products',
          slides: 3,
          quickviewEnabled: true
        }
      },
      {
        countryCode: 'can',
        options: {
          name: 'featuredProducts.OTHER GREAT BUSINESS BUILDING PRODUCTS',
          slides: 3,
          quickviewEnabled: true
        }
      }
    ];
    this.config = featuredProductsConfig.find(x => x.countryCode.toLowerCase() === this.isoCountryCode.toLowerCase());
    this.config = this.config || {
      countryCode: this.isoCountryCode,
      options: {
        name: 'featuredProducts.OTHER GREAT BUSINESS BUILDING PRODUCTS',
        slides: 3,
        quickviewEnabled: true
      }
    };
  }
  /**
   * to display releated products
   * @param  {number} productId
   * @param  {number} storeid
   */
  getFeaturedProducts(storeId: number) {
    this._productService
      .getFeaturedProducts(storeId, this.languageCode, 10, 1, '')
      .subscribe((response: any) => {
        if (response && response.length > 0) {
          this.featuredProducts = response;
          this.featuredProducts.forEach(x => x.productQuantity = 1);
          this.loadWishListProducts();
        }
      }, (error: any) => (this.errorMessages = <any>error));
  }
  /**
   * Get Recommended Products
   * @param  {number} storeId
   * @param  {number} productId
   * @param  {number} groupId
   * @returns void
   */
  getRecommendedProducts(storeId: number, productId: number, groupId: number): void {
    this._productService
      .getRecommendedProducts(storeId, productId, groupId, this.languageCode, 10, 1, '')
      .subscribe((response: any) => {
        if (response && response.length > 0) {
          this.featuredProducts = response;
          this.featuredProducts.forEach(x => x.productQuantity = 1);
          this.loadWishListProducts();
        }
      }, (error: any) => (this.errorMessages = <any>error));
  }
  /**
  * load wishlist
  */
  loadWishListProducts(): void {
    const wishListCart: Cart = this._cacheService.get(CacheKey.WishListSession);
    if (wishListCart && wishListCart.items.length > 0) {
      this.featuredProducts.forEach(x => {
        x.productQuantity = 1;
        wishListCart.items.forEach(y => {
          if (y.productId === x.id) {
            x.wishListItem = true;
          }
        });
      });
    }
  }
  /**
     * @returns void
     */
  wishListItemsBlock(): void {
    if (this.hideWishList) {
      this.featuredSliderConfig.slidesPerView = 5;
    }
  }
  ngOnDestroy(): void {
    // unsubscribe to avoid memory leaks
    if (this.hideItemsSubscription) {
      this.hideItemsSubscription.unsubscribe();
    }
  }
  getStoreData() {
    const result: StoreConfig = this._configurationService.getStoreData();
    if (result) {
      this.store = result;
      this.storeId = this.store.id;
      this.isEnableWishList = this.store.enableWishlist;
      if (result.purchaseFlows) {
        this.purchaseFlows = result.purchaseFlows;
        this.hasPurchaseFlow();
      }
    }
  }
  /**
   * Purchase flow
   */
  hasPurchaseFlow() {
    if (this.purchaseFlows.length > 0 && (this.store.purchaseFlows !== null && this.store.purchaseFlows.length > 0)) {
      this.purchaseFlows.forEach(flow => {
        this.store.purchaseFlows.forEach((storeFlow: any) => {
          if (flow.id === storeFlow.id && flow.name === this.personalPurchaseFlow) {
            this.isPersonalPurchaseFlow = true;
          }
        });
      });
    }
  }
  /**
  * show cart / Product detail based on variant.
  */
  addToCart(product: Product): void {
    const displayRestrictOrderNotification = this.memberOrderRestrictionService.validateUserByRestrictOrderRule();
    if (displayRestrictOrderNotification) {
      this._appMessageService.setShowRestrictOrderNotificationSubject();
      return;
    }
    if (product && product.options.length === 0) {
      if (!product.addingToCart) {
        this.manageShoppingCart(product, CartTypes.OrderCart);
      }
    } else if (product.productTypeMasterId === this.productType.Variable && product.options.length > 0) {
      this.showModalPopup(product);
    } else {
      this.gotoProductDetail(product.slug);
    }
  }
  /**
   * @param  {Product} product
   * @param  {CartTypes} cartType
   */
  private manageShoppingCart(product: Product, cartType: CartTypes) {
    product.addingToCart = true;
    const itemAddedNotification: any = this._translatePipe.get('Item added to cart');
    let cartSessionInfo: Cart = this._cacheService.get(CacheKey.CartSessionInfo);
    const item: Item = this._cartService.convertProductToItemMappper(product, cartSessionInfo);
    if (cartSessionInfo) {
      const cartItem = cartSessionInfo.items.filter(x => x.productId === item.productId)[0];
      if (cartItem) {
        let total: Number;
        total = cartItem.quantity + item.quantity;
        if (total > 999) {
          const cookieBannerDiscription: any = this._translatePipe.get('cookieBanner.We are sorry. You may not be able to order more than 1,000 units of an individual product at a time');

          this._notificationService.createNotification('', cookieBannerDiscription.value, NotificationType.ERROR, 5000);
          product.addingToCart = false;
          return;
        } else {
          item.quantity = cartItem.quantity + item.quantity;
        }
        if (item.quantity > product.stockQuantity && product.manageStock && !product.backOrderAllowed) {
          item.quantity = cartItem.quantity;
          product.errorMessage = true;
          setTimeout(() => {
            product.errorMessage = false;
          }, 2000);
         this._translatePipe.get('common.AvailableStock')
          .subscribe(res => {
            this._notificationService.createNotification('', res + product.stockQuantity, NotificationType.ERROR, 5000);
          });
          product.addingToCart = false;
          return;
        }
      }
      const mergeCartSession: Cart = JSON.parse(JSON.stringify(cartSessionInfo));
      // cartSessionInfo.items = _.remove(cartSessionInfo.items, function (n: any) {
      //   return n.productId !== product.id;
      // });
      this._cartService.updateCart([item], cartType, cartItem, cartSessionInfo).subscribe((response: any) => {
        product.addingToCart = false;
        if (response) {
          cartSessionInfo = this._cartService.mergeCartSession(item, response, mergeCartSession);
          this._cacheService.set(CacheKey.CartSessionInfo, cartSessionInfo);
          this._appMessageService.setMiniCart(response.sessionGuid);
          const shoppingCart = new Cart(cartSessionInfo, this.store);
          this._appMessageService.setCartItemsChanges(shoppingCart.itemsCount);
          this._appMessageService.showMiniCartView(product.id);
          // this._commonService.scrollTo('static-tempate', 500);
        }
      }, (error) => {
        product.addingToCart = false;
      });
    } else {
      this._cartService.saveCart([item], cartType).subscribe((response: any) => {
        product.addingToCart = false;
        if (response) {
          cartSessionInfo = this._cartService.mergeCartSession(item, response, cartSessionInfo);
          this._cacheService.set(CacheKey.CartSessionInfo, cartSessionInfo);
          this._appMessageService.setMiniCart(response.sessionGuid);
          const shoppingCart = new Cart(cartSessionInfo, this.store);
          this._appMessageService.setCartItemsChanges(shoppingCart.itemsCount);
          this._appMessageService.showMiniCartView(product.id);
          // this._commonService.scrollTo('static-tempate', 500);
        }
      }, (error) => {
        product.addingToCart = false;
      });
    }
  }
  /**
* To add an item
* @param  {Product} product
*/
  addToWishList(product: Product): void {
    // if (!this.userLoggedIn) {
    //   return;
    // }
    // TODO amruth - need to move text to s3 and translate
    if (!this.userLoggedIn) {
      // const cookieBannerData = {
      //   title: null,
      //   timeout: false,
      //   time: 2000,
      //   description: 'Please login or create an account in your first purchase to add products to your Favorites',
      //   notificationType: CookieBannerType.CartItemNotification
      // };
      // this._appMessageService.setCookieBannerData(cookieBannerData);
      return;
    }
    if (this.userLoggedIn && product.options && product.options.length > 0) {
      this.showModalPopup(product);
    } else {
      product.wishListItem = !product.wishListItem ? true : false;
      const item: Item = this._cartService.convertProductToItemMappper(product);
      let wishListCart: Cart = this._cacheService.get(CacheKey.WishListSession);
      if (product.wishListItem && wishListCart && wishListCart.items && wishListCart.items.length >= 0 && wishListCart.sessionGuid) {
        const cartItem: Item = wishListCart.items.find(x => x.productId === product.id);
        wishListCart.items = remove(wishListCart.items, function (n: any) {
          return n.productId !== product.id;
        });
        this._cartService
          .updateCart([item], CartTypes.WishlistCart, cartItem, wishListCart)
          .subscribe((response: Cart) => {
            if (response) {
              wishListCart = this._cartService.mergeCartSession(item, response, wishListCart);
              this._cacheService.set(CacheKey.WishListSession, wishListCart);
              this._appMessageService.setWishListItems();
            }
          });
      } else if (product.wishListItem) {
        this._cartService
          .saveCart([item], CartTypes.WishlistCart)
          .subscribe((response: Cart) => {
            if (response) {
              wishListCart = this._cartService.mergeCartSession(item, response, wishListCart);
              this._cacheService.set(CacheKey.WishListSession, wishListCart);
              this._appMessageService.setWishListItems();
            }
          });
      } else if (!product.wishListItem) {
        const cartItem: Item = wishListCart.items.find(x => x.productId === product.id);
        wishListCart.items = remove(wishListCart.items, function (n: any) {
          return n.productId !== product.id;
        });
        if (wishListCart && wishListCart.sessionGuid && cartItem && cartItem.id) {
          this._cartService
            .removeCartItem(wishListCart.sessionGuid, cartItem.id)
            .subscribe((response: any) => {
              wishListCart = new Cart(wishListCart, this.store);
              this._cacheService.set(CacheKey.WishListSession, wishListCart);
              this._appMessageService.setWishListItems();
            }, (error: any) => {
            });
        }
      }
    }
  }

  /**
  * redirect to sso login url
  * @param  {boolean} isLogin
  * @returns void
  */
  gotoLogin(isLogin: boolean, product: Product): void {
    this._cacheService.set(CacheKey.RedirectToFavourites, true);
    product.productQuantity = 1;
    this._cacheService.setCookieValue(CacheKey.WishListProduct, product.id);
    this._appMessageService.setNotifyLoginStatus(isLogin);
  }
  /**
  * Increment the product Quantity
  * @returns void
  */
  incrementQuantity(prod): void {
    prod.productQuantity = ++prod.productQuantity;
    prod.disableDecrement = false;
    if (!prod.stockAvailable || (prod.manageStock && !prod.backOrderAllowed && (prod.stockQuantity <=0 || prod.productQuantity > prod.stockQuantity))) {
    //if (prod.productQuantity > prod.stockQuantity && !prod.backOrderAllowed) {
      prod.errorMessage = true;
      setTimeout(() => {
        prod.errorMessage = false;
      }, 2000);
      prod.productQuantity = parseInt(prod.productQuantity, 10) - 1;
    }
  }
  /**
   * Decrement the product Quantity
   * @returns void
   */
  decrementQuantity(prod): void {
    if (prod.productQuantity > 1) {
      prod.productQuantity = parseInt(prod.productQuantity, 10) - 1;
    }
    if (prod.productQuantity === 1) {
      prod.disableDecrement = true;
    }
  }
  /**
   * to update product quantity
   */
  updateQuantity(prod: Product | any) {
    const qty = parseInt(prod.productQuantity, 10);
    if (!prod.stockAvailable || (prod.manageStock && !prod.backOrderAllowed && (prod.stockQuantity <=0 || qty > prod.stockQuantity))) {
    //if (qty > prod.stockQuantity && !prod.backOrderAllowed) {
      prod.errorMessage = true;
      setTimeout(() => {
        prod.errorMessage = false;
      }, 2000);
      prod.productQuantity = prod.stockQuantity;
    } else {
      prod.productQuantity = qty || null;
    }
    if (prod.productQuantity === 1) {
      prod.disableDecrement = true;
    }
    prod.disableDecrement = prod.productQuantity > 1 ? false : true;
  }
  // TODO @amruth need to update this method with language code and appropriate shop site
  /**
   * navigateToShop will redirect users to shop site to respective product details page based on slug
   * @param slug
   */
  navigateToShop(product: Product): void {
    let selectedCategory;
    if (product.categories) {
      selectedCategory = product.categories[0];
    }
    let redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase()
      + '/products/' + product.slug;
    this._cacheService.setCookieValue(CacheKey.SelectedCategoryId, this.catalog.id);
    if (selectedCategory) {
      this._cacheService.set(CacheKey.SelectedCategoryState, selectedCategory);
      if (selectedCategory.slug) {
        redirectUrl = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/' + this.languageCode.toLowerCase()
          + '/products/' + selectedCategory.slug + '/' + product.slug;
        this._cacheService.setCookieValue(CacheKey.SelectedCategoryId, this.catalog.id);
      }
    }
    redirectUrl = this._commonService.appendFBOID(redirectUrl);
    window.location.href = redirectUrl;
  }

  /**
 * Show Modal popup
 * @param product
 */
  showModalPopup(product: Product) {
    const initialState = {
      productDetails: product
    };
    this.bsModalRef = this.modalService.show(QuickviewComponent, { class: 'modal-lg modal-dialog-centered', initialState });
    this.bsModalRef.content.product = product;
  }
}
